import { AlertTriangle } from 'lucide-react';
import { useCompanyContext } from '../context/CompanyContext';
import { PLAN_LABELS } from '../constants/config';

/**
 * Banner mostrado cuando el override de límite de empresas (Programa Fundador)
 * venció — informa al usuario que ahora aplica el límite de su plan base.
 */
export default function CompanyLimitBanner() {
  const { companyLimitOverrideExpired, companyLimit, subscription } = useCompanyContext();

  if (!companyLimitOverrideExpired) return null;

  const planLabel = PLAN_LABELS[subscription?.plan ?? ''] ?? subscription?.plan ?? 'tu plan';
  const limiteTexto = companyLimit !== null
    ? `${companyLimit} empresa${companyLimit !== 1 ? 's' : ''}`
    : 'empresas ilimitadas';

  return (
    <div
      style={{ background: 'var(--surface-raised)', borderBottom: '1px solid var(--surface-raised)' }}
      className="flex items-center gap-2 px-6 py-2 text-sm text-[var(--warning)]"
    >
      <AlertTriangle size={14} className="icon-warn shrink-0" />
      <span>
        Tu acceso especial del Programa Fundador expiró. Ahora tienes {limiteTexto} según tu plan{' '}
        <strong>{planLabel}</strong>.
      </span>
    </div>
  );
}
